import {
  FindChangedCartOrderItem,
  FilterCartOrderItem,
  ToggleItemActionElements,
  Omit,
} from "@/libs/cart/order/utility/types";
import $ from "jquery";

/**
 * 注文確定されたアイテム一覧から一致した商品情報を返す
 * @param orderNum オーダー番号
 * @param itemCode 親アイテムコード
 * @param parentItemCode 子アイテムコード
 * @param items 注文確定された商品一覧
 */
export const findChangedCartOrderItem: FindChangedCartOrderItem = (
  orderNum,
  itemCode,
  parentItemCode,
  items
) => {
  return items.find(
    (v) =>
      v.orderNum === orderNum &&
      v.oyaItemCode === parentItemCode &&
      v.itemCode === itemCode
  );
};

/**
 * 指定した要素から条件によってフィルタリングした要素を返す
 * @param selector 指定した要素
 * @param findExpr 対象条件
 * @param filterExpr 除外条件
 */
export const filterCartOrderItem: FilterCartOrderItem = (
  selector,
  findExpr,
  filterExpr
) => {
  return $(selector).find(findExpr).not(filterExpr);
};

/**
 * 商品更新アクション要素の表示非表示を切り替える
 * @param setAttribute 属性を設定する関数
 * @param removeAttribute 属性を削除する関数
 * @param selectSelector セレクトボックスセレクタ
 * @param emptySelector 数量テキストセレクタ
 * @param restoreSelector 元に戻すセレクタ
 * @param deleteSelector 削除セレクタ
 */
export const toggleItemActionElements: ToggleItemActionElements = (
  setAttribute,
  removeAttribute,
  selectSelector,
  emptySelector,
  restoreSelector,
  deleteSelector
) => (current, $item, isDeleted) => {
  const $selectElement = $item.find(selectSelector);
  const $emptyElement = $item.find(emptySelector);
  const $toggleElement = isDeleted
    ? $item.find(restoreSelector)
    : $item.find(deleteSelector);
  setAttribute(current, "hidden", "true");
  removeAttribute($toggleElement, "hidden");
  if (isDeleted) {
    setAttribute($selectElement, "hidden", "true");
    removeAttribute($emptyElement, "hidden");
  } else {
    removeAttribute($selectElement, "hidden");
    setAttribute($emptyElement, "hidden", "true");
  }
};

/**
 * 特定のプロパティを削除した新しいオブジェクトを返す
 * @param obj オブジェクト
 * @param keys 削除したいプロパティ
 * @returns newObj 新しいオブジェクト
 */
export const omit: Omit = (obj, ...keys) => {
  const keysToRemove = new Set(keys.flat());
  return Object.fromEntries(
    Object.entries(obj).filter(([k]) => !keysToRemove.has(k))
  );
};
